import { FC } from "react";
import { FullHeightContainer } from "../../Common/views/FullHeightContainer";
import { LoadingView } from "../../Common/views/LoadingView";
import { HeaderConfig } from "../../Header/views/HeaderConfig";
import { useMyMember } from "../../Members/hooks/useMyMember";
import { useMyUser } from "../../Users/hooks/useMyUser";
import { ClientHomeOnboardingView } from "./ClientHomeOnboardingView";
import { ClientHomeView } from "./ClientHomeView";

export const ClientHomePage: FC = () => {
  const { user, isInitializing: userIsInitializing } = useMyUser();
  const { member, isInitializing: memberIsInitializing } = useMyMember();

  const isTeamMemberInvited = !!member?.tasks?.isTeamMemberInvited;
  const isTenderCreated = !!member?.tasks?.isTenderCreated;
  const areMemberTasksComplete =
    (isTenderCreated && isTeamMemberInvited) || !member;
  const isInitializing = userIsInitializing || memberIsInitializing;

  return (
    <>
      <HeaderConfig variant="WITH_NAVIGATION" />
      {isInitializing && (
        <FullHeightContainer>
          <LoadingView />
        </FullHeightContainer>
      )}
      {!isInitializing && member && !areMemberTasksComplete && (
        <ClientHomeOnboardingView member={member} />
      )}
      {!isInitializing && areMemberTasksComplete && user && (
        <ClientHomeView user={user} member={member} />
      )}
    </>
  );
};
